import logger from '@mna/logger'

const log = logger('App/workaroundForChromeOnMobile', (...args) => console.log(...args))

// https://stackoverflow.com/questions/39384154/calculating-viewport-height-on-chrome-android-with-css

let el, shouldApply = false

const targetRegexp = /android|webos|iphone|ipad|ipod|blackberry|nokia|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i

export const workaroundForChromeOnMobile = () => {

    if (!shouldApply || !el) return
    const minHeight = Math.min(document.documentElement.clientHeight, window.screen.height, window.innerHeight)
    el.style.height = minHeight

    //log('minHeight', minHeight)
}

export const startWorkaroundForChromeMobile = () => {

    shouldApply = typeof window !== 'undefined' && targetRegexp.test(navigator.userAgent.toLowerCase())
    //log('shouldApply', shouldApply)
    if (!shouldApply) return

    el = document.querySelector('#content')
    if (!el) return

    window.addEventListener('resize orientationchange', workaroundForChromeOnMobile, false)
    workaroundForChromeOnMobile()
}

export const stopWorkaroundForChromeMobile = () => {
    if (!shouldApply || !el) return
    window.removeEventListener('resize orientationchange', workaroundForChromeOnMobile, false)
}

export const IsChromeWithAndroid = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    var ischrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (/android/i.test(userAgent) && ischrome) {
        return true;
    }
    return false;
} 
